export default __webpack_public_path__ + "static/media/loyaltycash.aaf33784.png";